import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AppLoader from '../../../shared/components/app-loader';

import config from '../../../shared/services/config';
import AuthManager from '../../../shared/services/AuthManager';
import { isFunction } from 'lodash';
import Redirection from '../../../shared/services/redirection';
import { fetchOrCreatePlatformUser } from '../../../shared/actions/auth';
import Raven from 'raven-js';

import * as AuthEvents from '../../../shared/constants/cleverTapEvents';
import cleverTap from '../../../shared/services/cleverTap';
import { PARTNER_STAFF_USER_ROLE } from '../../../shared/constants/strings';
import { CONSOLIDATED_DASHBOARD_ROLE_NAME } from '../../../shared/constants/roles';
import { TeamAccountsTable } from './components/team-accounts-table';
import { TopBar } from '../../../shared/components/topbar';
import { Error } from '../../../shared/components/table'

class TeamAccounts extends React.Component {
  state = {
    errors: [],
    merchants: [],
    searchResults: [],
    error: undefined,
    message: undefined,
    showLoader: false,
    fetching: true,
    activeSlide: 1,
    slideSize: 4,
  };

  isMobile = window.matchMedia('(max-width: 576px)').matches;

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    pageHeading: PropTypes.string,
    forMobile: PropTypes.bool,
  };

  redirectUser = async (merchant, source) => {
    if (source === 'selectedMID') {
      let userData = JSON.parse(localStorage.user);
      var [e1, e2] = userData.email.split('@');
    } else {
      var [e1, e2] = merchant.email.split('@');
    }
    let identifier = `${e1}+${merchant.identifier}@${e2}`;
    let userProfile = {
      Name: merchant.name,
      Email: identifier,
      Phone: `+91${merchant.registered_mobile}`,
      Identity: identifier,
    };
    await cleverTap.onUserLogin({ Site: userProfile });
    await cleverTap.event(AuthEvents.LOGIN_INTO_BUSINESS, {
      Identity: identifier,
      'Email id': identifier,
      MID: merchant.mid,
      UUID: merchant.uuid,
      Role: merchant.acl_role_name,
    });
    const userData = {
      ...AuthManager.getUser(),
      ...this.merchantInfo(merchant),
    };
    AuthManager.persistUserToLocalStorage(userData);
    AuthManager.removeOutletDetailsFromCookies();
    if (config.get('isTestModeEnabled')) {
      this.setState({ showLoader: true })
      await AuthManager.createTestModeSession(userData?.product_account_uuid);
    }
    if (userData.outlet_flow_enabled) {
      this.props.history.push({
        pathname: `/account/team-accounts/${userData.mid}/outlets`,
      });
    } else {
      const loginRedirectUrl = config.get('loginRedirectUrl');
      if (isFunction(loginRedirectUrl)) {
        loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
      } else {
        this.props.history.push({
          pathname: loginRedirectUrl,
        });
      }
    }
  };

  isAdmin = (merchant) => {
    const user = AuthManager.getUser();
    return (
      merchant.admin_user_id === user.id &&
      merchant.email.toLowerCase() === user.email.toLowerCase()
    );
  };

  isAdminMerchant = (merchants) => {
    if (merchants.every(this.isAdmin)) {
      return true;
    } else {
      return false;
    }
  };

  merchantInfo = (merchant) => {
    if (this.newMerchantData) {
      const { merchant_uuid: merchantUuid } = this.newMerchantData;
      if (merchantUuid === merchant.uuid) {
        return {
          ...this.newMerchantData,
        };
      }
    }
    return {
      is_tnc_accepted: true,
      mid: merchant.mid || merchant.identifier,
      profile_completed: true,
      new_merchant: this.newMerchant || false,
      business_origin: merchant.business_origin,
      product: merchant.product,
      merchant_uuid: merchant.uuid,
      type: merchant.type,
      dashboard_preference: merchant.dashboard_preference,
      merchant_account_uuid: merchant.merchant_account_uuid,
      product_account_uuid: merchant.uuid,
      partner_uuid: merchant.partner_uuid,
      outlet_flow_enabled: merchant.outlet_flow_enabled,
      acl_role_name: merchant.acl_role_name,
      logo: merchant.logo,
    };
  };

  onMIDselection = async (merchant, merchantsList) => {
    let userData = JSON.parse(localStorage.user);
    await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
      'Button clicked': 'Business Selected',
      'Email id': userData.email,
      UUID: userData.uuid,
    });
    AuthManager.persistAclRoleNameToCookies(merchant.acl_role_name)
    AuthManager.persistConsolidatedProductAccountsToLocalStorage(
      merchant.acl_role_name == CONSOLIDATED_DASHBOARD_ROLE_NAME
      ? merchantsList
      : []
    )
    this.redirectUser(merchant, 'selectedMID');
  };


  merchantExists = () => {
    return this.state.merchants.length > 0;
  };

  componentWillMount() {
    const { history } = this.props;
    if (!AuthManager.isLoggedIn()) {
      window.location = '/app/account';
      return;
    }
    AuthManager.persistConsolidatedProductAccountsToLocalStorage([]);
  }

  async componentDidMount() {
    this.fetchMerchantsForUser();
  }

  fetchMerchantsForUser = async (fetching = true) => {
    this.setState({ fetching });
    const fetchUserMerchants = config.get('fetchUserMerchants', () => {});
    const merchants = await fetchUserMerchants();
    AuthManager.persistProductAccountsToCookies(merchants);
    let hideWelcomePage = false,
      redirectionUrl = Redirection.redirectionURL,
      userData = JSON.parse(localStorage.user);
    if (redirectionUrl)
      hideWelcomePage = !!redirectionUrl.match(/\/oauth\/authorize/);
    if (userData && userData.is_gc_enabled) {
      hideWelcomePage = true;
    }
    if (merchants) {
      if (merchants.length > 0) {
        cleverTap.event(AuthEvents.LOGIN_SUCCESSFULL, {
          UUID: userData.uuid,
          'Email id': userData.email,
        });
      }
      const emailMerchants = this.filterAdminMerchants(merchants);
      if (emailMerchants.length === 0) {
        await this.addMerchant(true, 'direct');
      } else if (this.newMerchant && !hideWelcomePage) {
        let merchantData = this.newMerchantData;
        let [e1, e2] = merchantData.email.split('@');
        let identifier = `${e1}+${merchantData.mid}@${e2}`;
        let userProfile = {
          Name: merchantData.name,
          Email: identifier,
          Phone: `+91${merchantData.registered_mobile}`,
          Identity: identifier,
        };
        await cleverTap.onUserLogin({ Site: userProfile });
        await cleverTap.event(AuthEvents.LOGIN_INTO_BUSINESS, {
          Identity: identifier,
          'Email id': identifier,
          MID: merchantData.mid,
          UUID: merchantData.uuid,
          Role: merchantData.acl_role_name,
        });
        const loginRedirectUrl = config.get('loginRedirectUrl');
        loginRedirectUrl(AuthManager.getUser(), true, Redirection.getURL());
        // if (merchantData.is_cs_eligible && merchantData.cs_plan) {
        //   window.location = '/app/plans';
        // } else {
        //   window.location = '/app/assessment';
        // }
      } else if (
        emailMerchants.length === 1 &&
        this.isAdminMerchant(emailMerchants)
      ) {
        return this.redirectUser(emailMerchants[0], 'adminMerchant');
      }
      merchants.reverse();
      const consolidatedEmailMerchants = emailMerchants.filter(m => m.acl_role_name == CONSOLIDATED_DASHBOARD_ROLE_NAME)
      const nonConsolidatedEmailMerchants = emailMerchants.filter(m => m.acl_role_name != CONSOLIDATED_DASHBOARD_ROLE_NAME)
      this.setState({
        merchants: emailMerchants,
        searchResults: [
          ...(consolidatedEmailMerchants.length ? [{
            ...consolidatedEmailMerchants[0],
            totalMids: consolidatedEmailMerchants.length,
          }] : []),
          ...nonConsolidatedEmailMerchants,
        ],
      });
    } else {
      this.setState({ error: 'No Merchant is allotted' });
    }
    setTimeout(() => this.setState({ fetching: false }), 1500);
  };

  filterAdminMerchants = (merchants) => {
    const user = AuthManager.getUser();
    return [
      ...merchants.filter(
        (merchant) =>
          merchant.admin_user_id === user.id &&
          merchant.email.toLowerCase() === user.email.toLowerCase()
      ),
      ...merchants.filter(
        (merchant) =>
          merchant.admin_user_id !== user.id &&
          merchant.acl_role_name !== PARTNER_STAFF_USER_ROLE
      ),
    ];
  };

  addMerchant = async (showLoader = false, source) => {
    let userData = JSON.parse(localStorage.user);
    if (source === 'button') {
      await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
        'Button clicked': 'Create a new account',
        'Email id': userData.email,
        UUID: userData.uuid,
      });
    }
    localStorage.setItem('tempToken', localStorage.getItem('tokenData'));
    await this.createPlatformUser(showLoader);
  };

  createPlatformUser = async (fetching = true) => {
    const user = AuthManager.getUser();
    const email = user.email,
      {
        state: {
          whatsapp_consent = false,
          website_detail,
          monthly_expected_volume,
        } = {},
      } = this.props.location;
    try {
      this.setState({ showLoader: true, errors: [] });
      const ALLOWED_QUERY_PARAMS = config.get('ALLOWED_QUERY_PARAMS');
      let createMerchantPayload = {
        email,
        can_create: true,
        whatsapp_consent: whatsapp_consent,
        website_detail,
        monthly_expected_volume:
          (monthly_expected_volume && monthly_expected_volume.value) || 0,
      };
      if (ALLOWED_QUERY_PARAMS) {
        createMerchantPayload = {
          ...ALLOWED_QUERY_PARAMS,
          ...createMerchantPayload,
        };
      }
      this.newMerchantData = await fetchOrCreatePlatformUser(
        this.props.dispatch,
        createMerchantPayload,
        user.uuid
      );
      this.newMerchant = this.newMerchantData.new_merchant;
      this.fetchMerchantsForUser(fetching);
      if (this.slider) {
        this.slider.slickGoTo(0);
      }
      this.setState({ showLoader: false });
    } catch (err) {
      const response = err.errors;
      if (response && response.need_email_verification) {
        this.props.history.replace({
          pathname: '/account/email/otp',
          state: {
            ...this.props.location.state,
            allowSkip: false,
            shiftUuid: true,
          },
        });
      } else {
        Raven.captureException(err);
        this.setState({
          showLoader: false,
          errors: this.state.errors.concat(err.message),
        });
      }
    }
  };

  shouldRenderAddButton = () => {
    const { merchants } = this.state;
    const user = AuthManager.getUser();
    if (!user) return false;
    const email = user.email;
    return !merchants.some(
      (merchant) => merchant.email.toLowerCase() === email.toLowerCase()
    );
  };

  singleUser = () => {
    return (
      !this.merchantExists() ||
      this.newMerchant ||
      this.isAdminMerchant(this.state.merchants)
    );
  };

  useDifferentAcc = async () => {
    let userData = JSON.parse(localStorage.user);
    await cleverTap.event(AuthEvents.MID_SCREEN_CLICKED, {
      'Button clicked': 'Use a different account',
      'Email id': userData.email,
      UUID: userData.uuid,
    });
    await cleverTap.event(AuthEvents.LOGOUT, {
      Email: userData.email,
    });
    localStorage.clear();
    window.location.href = '/app/account';
  };

  render() {
    const { showLoader, errors, fetching } = this.state;
    const hasError = errors.length !== 0;
    let topbarActions = [{
      label: 'Sign Out',
      onClick: this.useDifferentAcc,
      variant: 'SECONDARY',
      startIcon: { type: 'sign-out-alt' }
    }]

    if (this.shouldRenderAddButton() &&
      !fetching &&
      !this.singleUser())
      topbarActions = topbarActions.concat({
        label: 'Create new account',
        onClick: () => this.addMerchant(false, 'button'),
        variant: 'SECONDARY',
        startIcon: { type: 'add-icon' }
      })
    if (topbarActions.length == 2) {
      if (this.isMobile) {
        topbarActions[0].label = ''
        topbarActions[0].className = 'co-divider-right-border'
      }
      topbarActions[0].variant = 'LINK'
    }
    if (hasError) {
      const errorMsg = errors.join(', ')
      return (
        <div className='bg-white'>
          <TopBar actionBtns={topbarActions} />
          <div className='container tw-preflight'>
            <Error
              heading='Something went wrong'
              description={errorMsg}
              message={'Error!'}
              infographicType='internet-failure'
            />
          </div>
        </div>
      );
    } else {
      return (
        <>
          <TopBar actionBtns={topbarActions} />
          <div className='merchant-container textured-bg'>
            <div className='container cards-container'>
              {
                !showLoader ? (
                  <TeamAccountsTable
                    isLoading={fetching || !this.merchantExists()}
                    teamAccounts={this.state?.searchResults || []}
                    onSelection={(m) => this.onMIDselection(m, this.state.merchants)}
                  />
                ) : <AppLoader />
              }
            </div>
          </div>
        </>
      );
    }
  }
}

export default connect()(TeamAccounts);
